import type {WorkflowStepKey} from '../../types/filmWorkflow';
import type {EventPlan} from '../../types/film';
import type {WorkflowAssetsPreview} from '../../types/filmWorkflowAssets';
import {lazyWorkflowHandoff} from '../../services/api/workflowReadHandoff';
import {AK,startAssetsPreload,type AssetsPreloadApi} from './workflowAssetsPreload';
export interface WorkflowInitialReads {planId:string;step:WorkflowStepKey;subjects:Promise<any>;assetsPreview?:Promise<WorkflowAssetsPreview>}
/** A route hint is authoritative; without one, saved segmentation can identify the initial Assets view. */
export function workflowInitialStep(detail:EventPlan|null,requested:WorkflowStepKey|null|undefined):WorkflowStepKey|null{
 if(requested)return requested;
 if(!detail)return null;
 const events=detail.scenes.flatMap(s=>s.events);
 return events.length&&events.every(e=>e.genDurationS!=null)&&events.some(e=>e.dialogueLines?.length)?'ASSETS':'SCRIPT';
}
/**
 * `assets` (261029 P3 F1): có ⇒ bước ASSETS bắn CÙNG LÚC mọi GET Tài sản không phụ thuộc nhau vào chỗ giao một lần (xem `workflowAssetsPreload.ts`); `subjects`/`assetsPreview` của `initialReads`
 * thành «Promise lười» lấy từ CHÍNH chỗ giao đó (kiểm epoch ghi / generation / TTL lúc DÙNG và lúc response về). Không có ⇒ hành vi cũ (hai Promise sống).
 */
export function startWorkflowStepReads(planId:string,step:WorkflowStepKey,api:{getStepSubjects:(planId:string,step:any)=>Promise<any>;getAssetsPreview:(planId:string)=>Promise<any>},assets?:{storyId:string;api:AssetsPreloadApi}):WorkflowInitialReads|null{
 if(step==='SCRIPT'||step==='ASSEMBLY')return null;
 if(step==='ASSETS'&&assets){
  startAssetsPreload(planId,assets.storyId,assets.api);
  return {planId,step,subjects:lazyWorkflowHandoff(AK.assets(planId),()=>api.getStepSubjects(planId,step)),assetsPreview:lazyWorkflowHandoff(AK.assets(planId),()=>api.getAssetsPreview(planId))};
 }
 const reads:WorkflowInitialReads={planId,step,subjects:api.getStepSubjects(planId,step),...(step==='ASSETS'?{assetsPreview:api.getAssetsPreview(planId)}:{})};
 reads.subjects.catch(()=>undefined);reads.assetsPreview?.catch(()=>undefined);return reads;
}
/** Detail cần cho editor đang xem; maps/boards chỉ phục vụ đúng bước. */
export function workflowViewedSources(step:WorkflowStepKey|null|undefined){
 return {detail:true,boards:step==='STORYBOARD'||step==='PROMPT',maps:step==='MAP'||step==='STORYBOARD'};
}
/** Bắt đầu detail ngay khi route mở, không đặt sau status. */
export function startWorkflowPageReads(status:()=>unknown,detail:()=>unknown):void{status();detail();}
